import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { CompanyPartHeader } from "../../../components/PartHeader";
import { insertMarketPrice } from "../../../http/api/MarketPriceAPI";
import { CompanyTitledPage } from "../../TitledPage";
import MarketPriceSettingForm from "../components/MarketPriceSettingForm";
import { SYSTEM_PATH_COMPANY } from "../../../App";
import { useMarketPriceSettingForm } from "../hooks/useMarketPriceSettingForm";
import { useMarketPriceSettingValidation } from "../hooks/useMarketPriceSettingValidation";
import LoadingModal from "../../../components/LoadingModal";


// 新規荷主更新ページ
const MarketPriceSettingEditPage = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const form = useMarketPriceSettingForm();
  const {errors, hasErrors} = useMarketPriceSettingValidation(form);

  /** 「取得中」モーダルの表示状態を保持するstate */
  const [isLoading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      await form.loadFromMarketPriceId(location.state.marketPriceId);
      setLoading(false);
    })();
  }, [location.state]);

  // 更新ボタンをクリックするイベント
  async function handleClickUpdate() {
    try {
      const marketPriceId = await form.update();
      
      alert("更新完了しました。")
      navigate(SYSTEM_PATH_COMPANY + "/order_form_confirm", { state: { marketPriceId } })

    } catch (error) {    
      // TODO エラーの表示処理
      alert("更新失敗しました。")
    }
   
  }

  const handleClickReturn = (event) => {
    navigate(-1);
  };

  return (
    <CompanyTitledPage title="市況価格表編集">
      <CompanyPartHeader>
        <Grid container spacing={1}>
          <Grid item xs>
            <Typography fontWeight="bold" fontSize={20}>
              市況価格表情報
            </Typography>
          </Grid>
          <Grid item xs="auto">
            <Button
              variant="contained"
              onClick={handleClickUpdate}
              id="market-price-form-submit-button"
              disabled={hasErrors()}
            >
              更新
            </Button>
          </Grid>
          <Grid item xs="auto">
            <Button variant="outlined" onClick={handleClickReturn}>
              戻る
            </Button>
          </Grid>
        </Grid>
      </CompanyPartHeader>
      {/* 市況登録情報 */}
      <MarketPriceSettingForm form={form} errors={errors} />
      <LoadingModal open={isLoading} label="取得中" />
     
    </CompanyTitledPage>

  );
};

export default MarketPriceSettingEditPage;
